import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, AppState } from '../../../store';
import { EApiType, EDataTableType, EModuleType, TableHeaders } from '../../../data/Constants';
import { MaintenanceTable } from '../../Layouts/DataTable';
import { useApiError } from '../../../hooks';
import {
  getAllProperties,
  getFeaturePropertyAssociations,
} from '../../../store/states/PropertySlice';
import { setColumnsData } from '../../../services/DataHelperFunctions';

import type { IFeaturePropertyAssociation } from '../../../../types';

export const FeaturePropertyAssociation = (props: IFeaturePropertyAssociation) => {
  const dispatch = useDispatch<AppDispatch>();
  const errorElement = useApiError(EApiType.FeaturePropertyAssociationKey);
  const propertyList = useSelector((state: AppState) => state.dataMaintainance.propertyList);

  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (propertyList.length === 0) {
      dispatch(getAllProperties({ token: props.token }));
    }
  }, []);

  useEffect(() => {
    setColumnsData(
      propertyList,
      setColumns,
      TableHeaders[EDataTableType.FeaturePropertyAssociation].main
    );
  }, [propertyList]);

  if (errorElement) return errorElement;

  return (
    <MaintenanceTable
      token={props.token}
      type={EDataTableType.FeaturePropertyAssociation}
      getDataList={getFeaturePropertyAssociations}
      moduleType={EModuleType.Datamaintainance}
      productId={props.productId}
      columns={columns}
    />
  );
};
